module.exports = __webpack_public_path__ + "static/media/Wearpeachi_Product Listings.28ab72b4.docx";